import CampaignStatisticsUser from '@/interfaces/metrics.interface'
import onEnvironmentChange from '@/observables/environment.observable'
import Environment from '@interfaces/environment.interface'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { AxiosResponse } from 'axios'
import { take } from 'rxjs/operators'

export default class MariaHillService extends MainService {
  url: string
  logService = new LogService()

  constructor(mariaHillUrl?: string) {
    super()
    if (!mariaHillUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.mariaHill
      })
    } else {
      this.url = mariaHillUrl
    }
    this.logService.init('Maria Hill Service')
  }

  async getStatistics(idCampaign: string | number, socialId: string | number): Promise<CampaignStatisticsUser> {
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/campaigns/${idCampaign}/${socialId}/statistics/users/self`, { headers })
      .then((r: AxiosResponse) => r.data)
      .catch((error: any) => {
        this.logService.error({
          message: 'Can not get statistics user',
          error,
        })
        throw error.response
      })
  }
}
